import { Filter } from '../../ts/helpers/Filter';
import { GetUsersForDataAlertRequest, IGetUsersForDataAlertResult } from '../../ts/ServerApi/requests/GetUsersForDataAlertRequest';
import { IUser } from '../../ts/ServerApi/types/IUser';
import { ResourceQuery } from '../../ts/resources/ResourceQuery';
import { WebClientListResourceFetcher } from '../../commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';


export class DataAlertUsersResource {
  private fetcher = new WebClientListResourceFetcher(GetUsersForDataAlertRequest, (result: IGetUsersForDataAlertResult) => result.users);

  public getUsersQuery(dataAlertId: string, filter: string): ResourceQuery<IUser> {
    return new ResourceQuery<IUser>(this.fetcher)
      .withExtraParams({ 'dataAlertId': dataAlertId })
      .withFilters([Filter.stringFieldMatches('displayName', filter)]);
  }
}

export const DataAlertUsers = new DataAlertUsersResource();